import { render, staticRenderFns } from "./UserProfileDistributors.vue?vue&type=template&id=37e08ac1"
import script from "./UserProfileDistributors.vue?vue&type=script&lang=js"
export * from "./UserProfileDistributors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports